import { Alert } from '@vtex/shoreline'

import ListPagination from '~/components/ListPagination'
import Loading from '~/components/Loading'
import Table from '~/components/Table'
import { useAlert } from '~/hooks/useAlert'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import ReviewMediaModal from '../../ReviewMediaModal'
import { useMediaReviewTable } from './hooks/useMediaReviewTable'

const MediaReviewTable = () => {
  const { t } = useAPPTranslation()

  const {
    data,
    error,
    isLoading,
    isFetching,
    page,
    perPage,
    total,
    handlePagination,
    handleItemsPerPageChange,
    schema,
    openReviewItemId,
    setOpenReviewItemId
  } = useMediaReviewTable()

  const [AlertOnError] = useAlert(error)

  return (
    <>
      {openReviewItemId && (
        <ReviewMediaModal
          onClose={() => setOpenReviewItemId(null)}
          initialItemId={openReviewItemId}
        />
      )}

      <Loading status={!data && isLoading}>
        {t('common:actions.loadingData')}...
      </Loading>

      <AlertOnError />

      {!!data && !error && total === 0 && (
        <Alert variant="informational">
          <strong>{t('rm:reviewCampaign.media.allReviewed.title')}</strong>
          <p className="mb-0">
            {t('rm:reviewCampaign.media.allReviewed.description')}
          </p>
        </Alert>
      )}

      {!!total && (
        <>
          <Loading status={isFetching} onlyLine />
          {!!data && (
            <Table
              schema={schema}
              data={data}
              total={total}
              hasHeader={false}
              sideBorder
              smallerRowPadding
            />
          )}
          {total > perPage && (
            <footer className="d-flex flex-direction-column align-items-center">
              <ListPagination
                total={total}
                label={total > 1 ? t('rm:ads') : t('rm:ad')}
                currentPage={page}
                itemsPerPage={perPage}
                menuPlacement="top"
                onClickPagination={handlePagination}
                onItemsPerPageChange={handleItemsPerPageChange}
              />
            </footer>
          )}
        </>
      )}
    </>
  )
}

export default MediaReviewTable
